import Flickity from "../externals/flickity/wwdevFlickity";

class titleTextProductImage {
	constructor(config) {
		this.config = Object.assign({
			scope: '.title_text_product_image'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		var flkty = new Flickity('.flickity-carousel');
		var carouselStatus = document.querySelector('.carousel-status');

		function updateStatus() {
			var slideNumber = flkty.selectedIndex + 1;
			carouselStatus.textContent = slideNumber + ' ' + '/' + ' ' + flkty.slides.length + ' ';
		}
		updateStatus();

		flkty.on( 'select', updateStatus );
	}
}

export default new titleTextProductImage;